// extracted by extract-css-chunks-webpack-plugin
module.exports = {"outer":"BrandMenuItem-d6f9f9e4621da015","inner":"BrandMenuItem-8f0402783609df9a","text":"BrandMenuItem-97e787a87f9f1a20","image":"BrandMenuItem-4300c686da539df8"};